const listeners = new Set();
let _updateAvailable = false;
let _triggerUpdate = null;

export function isUpdateAvailable() {
  return _updateAvailable;
}

export function onUpdateChange(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function notifyUpdateAvailable(triggerFn) {
  _updateAvailable = true;
  _triggerUpdate = triggerFn;
  listeners.forEach(fn => fn(true));
}

// RMI-2026-450: workbox-window's messageSkipWaiting() (called via
// _triggerUpdate -> updateSW(true)) is a silent no-op if
// registration.waiting has already gone null by click time -- on a
// long-lived desktop tab the waiting worker can be superseded/cleared
// between when the UPDATE button first appears (onNeedRefresh) and when
// someone actually clicks it, since main.jsx polls registration.update()
// every 60s. No error surfaces and no reload happens in that case, so the
// click looked like it did nothing. Fall back to a hard unregister+reload
// if the normal skipWaiting -> controllerchange -> reload path (main.jsx)
// hasn't already navigated away within a few seconds.
export function triggerUpdate() {
  if (_triggerUpdate) _triggerUpdate();
  setTimeout(async () => {
    try {
      const regs = await navigator.serviceWorker.getRegistrations();
      await Promise.all(regs.map(r => r.unregister()));
    } catch (_) { /* best-effort fallback */ }
    window.location.reload();
  }, 3000);
}
